"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var MonozygoticChild_1 = __importDefault(require("./MonozygoticChild"));
var Gender_1 = __importDefault(require("./Gender"));
var Weight_1 = __importDefault(require("./Weight"));
var ApgarScore_1 = __importDefault(require("./ApgarScore"));
var BirthStatus_1 = __importDefault(require("./BirthStatus"));
var BirthStatusOptional_1 = __importDefault(require("./BirthStatusOptional"));
var AfterBirth_1 = __importDefault(require("./AfterBirth"));
;
var InfantInfoForm = /** @class */ (function (_super) {
    __extends(InfantInfoForm, _super);
    function InfantInfoForm(props) {
        var _this = _super.call(this, props) || this;
        var state = form_store_1.default.getState();
        _this.state = state;
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            if (_this._isMounted) {
                _this.setState(form_store_1.default.getState());
            }
        });
        return _this;
    }
    InfantInfoForm.prototype.componentDidMount = function () {
        this._isMounted = true;
    };
    InfantInfoForm.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    InfantInfoForm.prototype.getOptionalElem = function (number) {
        var birth_status_value = this.state.data["birth_status_".concat(number)];
        var birth_status_option_value = this.state.data["birth_status_option_".concat(number)];
        var optionalElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (parseInt(birth_status_value) > 1 || birth_status_option_value.indexOf("2") > -1 || birth_status_option_value.indexOf("3") > -1 || birth_status_option_value.indexOf("4") > -1 || birth_status_option_value.indexOf("5") > -1) {
            optionalElem = (react_1.default.createElement("div", { className: "form__field" },
                react_1.default.createElement("label", { className: "form__label" },
                    "\u4E0A\u8A18\u3001\u300C\u8607\u751F\u300D\u300CNICU\u5165\u9662\u300D\u300C\u5947\u5F62\u300D\u300C\u969C\u5BB3\u300D\u300C\u6B7B\u7523\u300D\u3092\u9078\u629E\u3055\u308C\u305F\u5834\u5408\u306E\u5185\u5BB9",
                    react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                react_1.default.createElement(BirthStatusOptional_1.default, { number: number })));
        }
        return optionalElem;
    };
    InfantInfoForm.prototype.render = function () {
        var number = this.props.number;
        var optionalElem = this.getOptionalElem(number);
        return (react_1.default.createElement("div", { className: "form__container" },
            react_1.default.createElement("p", { className: "form__heading" },
                "\u7B2C",
                number,
                "\u5150"),
            react_1.default.createElement("div", { className: "form__block" },
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("fieldset", { className: "form__field" },
                        react_1.default.createElement("legend", { className: "form__title" },
                            react_1.default.createElement("span", { className: "form__label" }, "\u4E00\u5375\u6027\u591A\u80CE"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(MonozygoticChild_1.default, { number: number })))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("fieldset", { className: "form__field" },
                        react_1.default.createElement("legend", { className: "form__title" },
                            react_1.default.createElement("span", { className: "form__label" }, "\u6027\u5225"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(Gender_1.default, { number: number })))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("div", { className: "form__title" },
                        react_1.default.createElement("label", { htmlFor: "weight01", className: "form__label" }, "\u4F53\u91CD"),
                        react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                    react_1.default.createElement("div", { className: "form__input" },
                        react_1.default.createElement(Weight_1.default, { number: number }))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("div", { className: "form__title" },
                        react_1.default.createElement("span", { className: "form__label" }, "\u30A2\u30D7\u30AC\u30FC\u30B9\u30B3\u30A2")),
                    react_1.default.createElement("div", { className: "form__input form__input--multi" },
                        react_1.default.createElement(ApgarScore_1.default, { number: number }))),
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("fieldset", { className: "form__field" },
                        react_1.default.createElement("legend", { className: "form__title" },
                            react_1.default.createElement("span", { className: "form__label" }, "\u51FA\u7523\u5F8C\u306E\u72B6\u614B"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input" },
                            react_1.default.createElement(BirthStatus_1.default, { number: number })))),
                optionalElem,
                react_1.default.createElement("div", { className: "form__item" },
                    react_1.default.createElement("fieldset", { className: "form__field" },
                        react_1.default.createElement("legend", { className: "form__title" },
                            react_1.default.createElement("span", { className: "form__label" }, "\u51FA\u751F\u5F8C\uFF08\uFF11\u30F6\u6708\uFF09"),
                            react_1.default.createElement("span", { className: "form__required" }, "\uFF0A")),
                        react_1.default.createElement("div", { className: "form__input form__input--multi" },
                            react_1.default.createElement(AfterBirth_1.default, { number: number })))))));
    };
    return InfantInfoForm;
}(react_1.Component));
exports.default = InfantInfoForm;
